import React, { useEffect, useState, useLayoutEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import clsx from 'clsx';
import './NavMenu.css';
import IdleTimer from 'react-idle-timer';

import AppBar from '@material-ui/core/AppBar';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import TextEvents from 'app/components/TextEvents';
import SuperLoader from 'app/components/SuperLoader';
import Typography from '@material-ui/core/Typography';
import { useStyles, styles } from './NavMenuStyles';
import { Avatar, Icon, Button, Tooltip, Badge, Modal, } from 'antd'
// import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import { version } from '../../package.json';
import Auth from '../config/auth'
import { PURGE } from 'redux-persist';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEmployeeById } from 'app/actions/LoginActions';
import { clearAll, fetchPendingCommunication } from 'app/actions/CommunicationActions';
import { clearAllStates } from 'app/actions/LoginActions';
import { fetchDisclaimerActive } from 'app/actions/DisclaimerActions';
import { IDMScreen, auth, employeeById, erapidsRefreshTokenError } from 'app/reducers';
import { getPendingCommunication } from '../app/reducers/index';


import isEmpty from 'app/utils/IsEmpty';


const NavMenu = (props) => {
    const dispatch = useDispatch();
    const authScreen = useSelector(IDMScreen)
    const employeeData = useSelector(employeeById)
    const refresh = useSelector(erapidsRefreshTokenError)
    const authData = useSelector(auth)
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState('');
    const [openList, setOpenList] = useState(false);
    const [openManagement, setMng] = useState(false);
    const [openAdmin, setAdmin] = useState(false);
    const [openReports, setReports] = useState(false);
    const [openGraphs, setGraphs] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [message, setMessage] = useState("Subiendo Archivo...");
    const [loader, setLoading] = useState(false);
    const year = new Date().getFullYear();
    const pendingCommunication = useSelector(getPendingCommunication);

    useEffect(() => {
        setSelectedIndex(props.SelectedIndex);
        dispatch(fetchDisclaimerActive())
        dispatch(fetchPendingCommunication((authData.User.IdCompany == null ? authData.User.UserId : authData.User.IdCompany)))
        if (isEmpty(employeeData) && props.isCommunicationStatus === false) dispatch(fetchEmployeeById((authData.User.IdCompany == null ? authData.User.UserId : authData.User.IdCompany)))
    }, []);

    useLayoutEffect(() => {
        if (typeof refresh === 'object') {
            setLoading(true);
            setMessage('Redirigiendo...');
            setTimeout(() => {
                props.history.push({
                    pathname: '/',
                    state: 'MI DATA de Login',
                    result: () => {
                        dispatch(clearAll());
                        dispatch(clearAllStates());
                    }
                })
            }, 2000);
        }
    });

    const handleDrawerOpen = () => {
        setOpen(true)
        props.isAdmin ? setAdmin(true) : props.isCatalog ? setOpenList(true) : props.isManag ? setMng(true) : props.isRepor ? setReports(true) : props.isGraph ? setGraphs(true) : setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
        setOpenList(false);
        setMng(false)
        setAdmin(false)
        setReports(false);
        setGraphs(false);
    };
    const onSubmit = (screen) => {
        props.history.push({
            pathname: screen,
        })
    };
    const handleClick = () => {
        setOpenList(!openList);
        setOpen(true);
    };
    const handleClickManagement = () => {
        setMng(!openManagement);
        setOpen(true);
    };
    const handleClickAdmin = () => {
        setAdmin(!openAdmin);
        setOpen(true);
    };
    //Sesion Out for time idle
    const idleTimer = useRef(null)
    const [visibleModal, setVisibleModal] = useState(false);


    const onIdle = () => {
        // if(!visibleModal){
        // setVisibleModal(true);
        // }
        const location = window.location.href;

        if(!location.includes('ComplianceMatrixbyPositionScreen')){
            sessionOut();
        }
    }

    const sessionOut = () => {
        setVisibleModal(false);
        setLoading(true);
        setMessage('Redirigiendo...');
        setTimeout(() => {
            props.history.push({
                pathname: '/',
                state: 'MI DATA de Login',
                sesionExp: true,
                result: () => {
                    dispatch(clearAll());
                    dispatch(clearAllStates());
                }
            })
        }, 2000);
    }

    const handleClickReports = () => {
        setReports(!openReports);
        setOpen(true);
    };

    const handleClickGraphs = () => {
        setGraphs(!openGraphs);
        setOpen(true);
    };

    const mainListItems = () => {
        let filtered = authScreen.filter(i => i.ActionUrl !== '*' && i.ParentScreen !== 'Catálogos' && i.ParentScreen !== 'Gestión' && i.ParentScreen !== 'Administración' && i.ParentScreen !== 'Reportes' && i.ParentScreen !== 'Gráficas')
        const childrens = authScreen.filter(i => i.ParentScreen === 'Catálogos')
        const management = authScreen.filter(i => i.ParentScreen === 'Gestión')
        const admin = authScreen.filter(i => i.ParentScreen === 'Administración')
        const reports = authScreen.filter(i => i.ParentScreen === 'Reportes')
        const graphs = authScreen.filter(i => i.ParentScreen === 'Gráficas')

        const catalogsOBJ = {
            ActionUrl: '',
            Icon: 'read',
            Screens: childrens,
            ScreenId: 1,
            ScreenName: 'Catalogs',
            SelectedIndex: 1003415,
            Tooltip: 'Catálogos'
        }
        const managementOBJ = {
            ActionUrl: '',
            Icon: 'solution',
            Screens: management,
            ScreenId: 2,
            ScreenName: 'management',
            SelectedIndex: 2003416,
            Tooltip: 'Gestión'
        }
        const adminOBJ = {
            ActionUrl: '',
            Icon: 'reconciliation',
            Screens: admin,
            ScreenId: 3,
            ScreenName: 'management',
            SelectedIndex: 2003417,
            Tooltip: 'Administración'
        }

        const graphsOBJ = {
            ActionUrl: '',
            Icon: 'bar-chart',
            Screens: graphs,
            ScreenId: 5,
            ScreenName: 'graphs',
            SelectedIndex: 2003418,
            Tooltip: 'Gráficas'
        }

        const reportsOBJ = {
            ActionUrl: '',
            Icon: 'file-text',
            Screens: reports,
            ScreenId: 4,
            ScreenName: 'reports',
            SelectedIndex: 2003419,
            Tooltip: 'Reportes'
        }

        filtered.push(adminOBJ)
        filtered.push(catalogsOBJ)
        filtered.push(managementOBJ)
        filtered.push(graphsOBJ)
        filtered.push(reportsOBJ)

        // let parentList=[]
        // filtered.forEach(i=> {
        //     const mylist=[];
        //     mylist.push(i.ParentScreen)
        //      parentList=[...new Set(mylist)]
        //     }
        // );
        const isCatalogs = authScreen.find(i => i.ParentScreen === 'Catálogos')
        const isManagement = authScreen.find(i => i.ParentScreen === 'Gestión')
        const isAdmin = authScreen.find(i => i.ParentScreen === 'Administración')
        const isReports = authScreen.find(i => i.ParentScreen === 'Reportes')
        const isGraphs = authScreen.find(i => i.ParentScreen === 'Gráficas')

        if (isCatalogs === undefined && isManagement === undefined && isAdmin === undefined && isReports === undefined && isGraphs === undefined) {
            const newfilt = filtered.filter(i => i.Tooltip !== 'Catálogos' && i.Tooltip !== 'Gestión' && i.Tooltip !== 'Administración' && i.Tooltip !== 'Reportes' && i.Tooltip !== 'Gráficas');
            filtered = newfilt;
        }
        return filtered.map((data, key) => {
            data['SelectedIndex'] = key;
            return (
                <List key={data.ScreenId} style={styles.listPadding}>
                    {data.Tooltip === 'Administración' && data.Screens.length !== 0 ?
                        <div>
                            <ListItem button selected={props.isAdmin} className={classes.nestedSingle} onClick={handleClickAdmin} style={{ paddingLeft: '10px', paddingRight: '24px' }}>
                                <Tooltip key={data.Tooltip} title={data.Tooltip} placement="right">
                                    <ListItemIcon style={{ minWidth: '35px' }}>
                                        <Icon type={data.Icon} style={styles.menuIcons} />
                                    </ListItemIcon>
                                </Tooltip>
                                <ListItemText primary={data.Tooltip} classes={{ primary: classes.listItemText }} />
                                {openAdmin ? <Icon type="up" style={styles.menuUpDown} /> : <Icon type="down" style={styles.menuUpDown} />}
                            </ListItem>
                            <Collapse in={openAdmin} timeout="auto" unmountOnExit className={classes.collapseBG}>
                                <List component="div" disablePadding>
                                    {data.Screens.map(i => {
                                        return (
                                            <ListItem key={i.ScreenId} button className={classes.nested} selected={selectedIndex === i.ActionUrl} onClick={() => onSubmit(i.ActionUrl)} >
                                                <ListItemText primary={i.Tooltip} classes={{ primary: classes.listItemTextChildren }} />
                                            </ListItem>
                                        )
                                    }
                                    )}
                                </List>
                                <Divider />
                            </Collapse>
                        </div>
                        : ''}
                    {data.Tooltip === 'Catálogos' && data.Screens.length !== 0 ?
                        <div>
                            <ListItem button selected={props.isCatalog} onClick={handleClick} className={classes.nestedSingle} style={{ paddingLeft: '10px', paddingRight: '24px' }}>
                                <Tooltip key={data.Tooltip} title={data.Tooltip} placement="right">
                                    <ListItemIcon style={{ minWidth: '35px' }}>
                                        <Icon type={data.Icon} style={styles.menuIcons} />
                                    </ListItemIcon>
                                </Tooltip>
                                <ListItemText primary={data.Tooltip} classes={{ primary: classes.listItemText }} />
                                {openList ? <Icon type="up" style={styles.menuUpDown} /> : <Icon type="down" style={styles.menuUpDown} />}
                            </ListItem>
                            <Collapse in={openList} timeout="auto" unmountOnExit className={classes.collapseBG}>
                                <List component="div" disablePadding>
                                    {data.Screens.map(i => {
                                        return (
                                            <ListItem key={i.ScreenId} button className={classes.nested} selected={selectedIndex === i.ActionUrl} onClick={() => onSubmit(i.ActionUrl)} >
                                                <ListItemText primary={i.Tooltip} classes={{ primary: classes.listItemTextChildren }} />
                                            </ListItem>
                                        )
                                    }
                                    )}
                                </List>
                                <Divider />
                            </Collapse>
                        </div>
                        : ''}
                    {data.Tooltip === 'Gestión' && data.Screens.length !== 0 ?
                        <div>
                            <ListItem button onClick={handleClickManagement} selected={props.isManag} className={classes.nestedSingle} style={{ paddingLeft: '10px', paddingRight: '24px' }}>
                                <Tooltip key={data.Tooltip} title={data.Tooltip} placement="right">
                                    <ListItemIcon style={{ minWidth: '35px' }}>
                                        <Icon type={data.Icon} style={styles.menuIcons} />
                                    </ListItemIcon>
                                </Tooltip>
                                <ListItemText primary={data.Tooltip} classes={{ primary: classes.listItemText }} />
                                {openManagement ? <Icon type="up" style={styles.menuUpDown} /> : <Icon type="down" style={styles.menuUpDown} />}
                            </ListItem>
                            <Collapse in={openManagement} timeout="auto" unmountOnExit className={classes.collapseBG}>
                                <List component="div" disablePadding>
                                    {data.Screens.map(i => {
                                        return (
                                            <ListItem key={i.ScreenId} button className={classes.nested} selected={selectedIndex === i.ActionUrl} onClick={() => onSubmit(i.ActionUrl)} >
                                                <ListItemText primary={i.Tooltip} classes={{ primary: classes.listItemTextChildren }} />
                                            </ListItem>
                                        )
                                    }
                                    )}
                                </List>
                                <Divider />
                            </Collapse>
                        </div>
                        : ''}
                    {data.Tooltip === 'Gráficas' && data.Screens.length !== 0 ?
                        <div>
                            <ListItem button onClick={handleClickGraphs} selected={props.isGraph} className={classes.nestedSingle} style={{ paddingLeft: '10px', paddingRight: '24px' }}>
                                <Tooltip key={data.Tooltip} title={data.Tooltip} placement="right">
                                    <ListItemIcon style={{ minWidth: '35px' }}>
                                        <Icon type={data.Icon} style={styles.menuIcons} />
                                    </ListItemIcon>
                                </Tooltip>
                                <ListItemText primary={data.Tooltip} classes={{ primary: classes.listItemText }} />
                                {openGraphs ? <Icon type="up" style={styles.menuUpDown} /> : <Icon type="down" style={styles.menuUpDown} />}
                            </ListItem>
                            <Collapse in={openGraphs} timeout="auto" unmountOnExit className={classes.collapseBG}>
                                <List component="div" disablePadding>
                                    {data.Screens.map(i => {
                                        return (
                                            <ListItem key={i.ScreenId} button className={classes.nested} selected={selectedIndex === i.ActionUrl} onClick={() => onSubmit(i.ActionUrl)} >
                                                <ListItemText primary={i.Tooltip} classes={{ primary: classes.listItemTextChildren }} />
                                            </ListItem>
                                        )
                                    }
                                    )}
                                </List>
                                <Divider />
                            </Collapse>
                        </div>
                        : ''}
                    {data.Tooltip === 'Reportes' && data.Screens.length !== 0 ?
                        <div>
                            <ListItem button onClick={handleClickReports} selected={props.isRepor} className={classes.nestedSingle} style={{ paddingLeft: '10px', paddingRight: '24px' }}>
                                <Tooltip key={data.Tooltip} title={data.Tooltip} placement="right">
                                    <ListItemIcon style={{ minWidth: '35px' }}>
                                        <Icon type={data.Icon} style={styles.menuIcons} />
                                    </ListItemIcon>
                                </Tooltip>
                                <ListItemText primary={data.Tooltip} classes={{ primary: classes.listItemText }} />
                                {openReports ? <Icon type="up" style={styles.menuUpDown} /> : <Icon type="down" style={styles.menuUpDown} />}
                            </ListItem>
                            <Collapse in={openReports} timeout="auto" unmountOnExit className={classes.collapseBG}>
                                <List component="div" disablePadding>
                                    {data.Screens.map(i => {
                                        return (
                                            <ListItem key={i.ScreenId} button className={classes.nested} selected={selectedIndex === i.ActionUrl} onClick={() => onSubmit(i.ActionUrl)} >
                                                <ListItemText primary={i.Tooltip} classes={{ primary: classes.listItemTextChildren }} />
                                            </ListItem>
                                        )
                                    }
                                    )}
                                </List>
                                <Divider />
                            </Collapse>
                        </div>
                        : ''}

                    {data.Tooltip !== 'Catálogos' && data.Tooltip !== 'Gestión' && data.Tooltip !== 'Administración' && data.Tooltip !== 'Reportes' && data.Tooltip !== 'Gráficas' ?
                        <ListItem button selected={selectedIndex === data.ActionUrl} onClick={() => onSubmit(data.ActionUrl)} className={classes.nestedSingle} >
                            <Tooltip key={data.Tooltip} title={data.Tooltip} placement="right">
                                <ListItemIcon key={data.ScreenName} style={{ minWidth: '35px' }}>
                                    {data.Tooltip == 'Mis Comunicaciones' ?
                                        <Badge size="small" count={pendingCommunication.length > 0 ? pendingCommunication[0].totalcount : 0}>
                                            <Icon type={data.Icon} style={styles.menuIcons} />
                                        </Badge>
                                        :
                                        <Icon type={data.Icon} style={styles.menuIcons} />
                                    }
                                </ListItemIcon>
                            </Tooltip>
                            <ListItemText primary={data.Tooltip} classes={{ primary: classes.listItemText }} />
                        </ListItem> : ''}

                </List>
            )
        })
    }
    return (
        <div className={classes.root}>
            {props.video || loader ? <SuperLoader loading={true} message={message}></SuperLoader> : ''}
            <AppBar position='absolute' className={clsx(classes.appBar, open && classes.appBarShift)}>
                <Toolbar className={classes.toolbar}>
                    {props.isCommunicationStatus ? <div /> : <IconButton
                        edge='start'
                        color='inherit'
                        aria-label='Open drawer'
                        onClick={handleDrawerOpen}
                        className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                    >
                        <Icon type='menu-unfold' style={{ color: '#001c33' }} />
                    </IconButton>}
                    <Typography component='h1' variant='h6' color='inherit' noWrap className={classes.title}>
                        {props.header ? props.header : 'Dashboard'}
                    </Typography>
                    {/* {props.isCommunicationStatus ? <div/> : <IconButton color='inherit'>
                    <Badge badgeContent={0} color='secondary'>
                    <Icon type='notification' style={{ fontSize: '20px' }}/>
                    </Badge>
                </IconButton>} */}
                    {props.isCommunicationStatus ? <div /> :
                        <IconButton color='inherit' onClick={() => setIsVisible(true)}>
                            <Avatar icon='user' src={typeof employeeData === 'undefined' ? '' : employeeData.avatar} />
                        </IconButton>
                    }
                </Toolbar>
            </AppBar>
            {props.isCommunicationStatus ? <div /> :
                <Drawer
                    variant='permanent'
                    classes={{
                        paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose)
                    }}
                    open={open}
                >
                    <div className={classes.toolbarIcon}>
                        <Grid
                            container
                            direction='row'
                            justify='center'
                            alignItems='center'
                            className={classes.containerHeaderNav}
                        >
                            <Grid item xs={2}>
                                <img
                                    alt="example"
                                    src={require("../assets/COTEMAR - HSEQ - COTEPLAY - LOGO V2-11-11 1.png")}
                                    style={{ width: ' 80%', height: '80%' }}
                                />
                            </Grid>

                            <Grid item xs={3}>
                                <TextEvents
                                    text='Cotplay'
                                    color='white'
                                    size='label'
                                    weight='medium'
                                    textAlign='center'
                                />
                            </Grid>
                            <Grid item xs={6} className={classes.menuFoldStyle}>
                                <IconButton onClick={handleDrawerClose}>
                                    <Icon type='menu-fold' style={styles.menuIcons} />
                                </IconButton>
                            </Grid>

                        </Grid>

                    </div>
                    <Divider />
                    {mainListItems()}
                    <Divider />
                </Drawer>}
            {typeof employeeData === 'undefined' ? '' : <Drawer classes={{ paper: classes.drawer }} anchor='right' open={isVisible} onClose={() => setIsVisible(false)}>
                <Grid
                    container
                    direction='row'
                    justify='center'
                    alignItems='center'
                    className={classes.containerEmployeeCard}
                >
                    <Grid item xs={12}>
                        <div>
                            <IconButton onClick={() => setIsVisible(false)} size={'small'}>
                                <Icon type="arrow-left" style={{ fontSize: '14px' }} />
                            </IconButton>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <div className={classes.avatarRoot}>
                            <Avatar size={100} icon='user' src={employeeData.avatar} />
                        </div>
                    </Grid>
                    <Grid item xs={12} className={classes.gridItem}>
                        <Grid xs={12} item className={classes.gridSeparatorTop}>
                            <TextEvents
                                text={'Nombre'}
                                color='cotemar'
                                size='tiny'
                                weight='medium'
                            />
                            <TextEvents
                                text={employeeData.firstName + ' ' + employeeData.lastName}
                                color='darker'
                                size='label'
                                weight='medium'
                            />
                        </Grid>
                        <Divider />
                        <Grid xs={12} item className={classes.gridSeparatorTop}>
                            <TextEvents
                                text={'Ficha'}
                                color='cotemar'
                                size='tiny'
                                weight='medium'
                            />
                            <TextEvents
                                text={employeeData.employeeId}
                                color='darker'
                                size='label'
                                weight='medium'
                            />
                        </Grid>
                        <Divider />
                        <Grid xs={12} item className={classes.gridSeparatorTop}>
                            <TextEvents
                                text={'Categoría'}
                                color='cotemar'
                                size='tiny'
                                weight='medium'
                            />
                            <TextEvents
                                text={employeeData.categoryName === null ? 'N/A' : employeeData.categoryName}
                                color='darker'
                                size='label'
                                weight='medium'
                            />
                        </Grid>
                        <Divider />
                        <Grid xs={12} item className={classes.gridSeparatorTop}>
                            <TextEvents
                                text={'Subdirección'}
                                color='cotemar'
                                size='tiny'
                                weight='medium'
                            />
                            <TextEvents
                                text={employeeData.subdirectionName === null || employeeData.subdirectionName === '' ? 'N/A' : employeeData.subdirectionName}
                                color='darker'
                                size='label'
                                weight='medium'
                            />
                        </Grid>
                        <Divider />
                        <Grid xs={12} item className={classes.gridSeparatorTopButton}>
                            <Auth>
                                {(params) => {
                                    return (
                                        <Button type='danger' ghost icon='logout' size={'default'} block
                                            onClick={() => params.logOut(() => {
                                                dispatch(clearAll())
                                                dispatch(clearAllStates())
                                                dispatch({
                                                    type: PURGE,
                                                    key: 'root',
                                                    result: () => {
                                                        params.logOut(() => {
                                                            props.history.push('/');
                                                        }, true);
                                                    }
                                                });

                                            })}>
                                            Cerrar sesión
                                        </Button>
                                    )
                                }}
                            </Auth>
                        </Grid>

                        <Grid item xs={12} className={classes.gridSeparatorTop}>
                            <Grid className={classes.version}>
                                <Chip
                                    className={classes.version}
                                    label={'versión: ' + version}
                                    size="small"
                                />
                            </Grid>
                            <Grid className={classes.version}>
                                <div className={classes.content1} style={styles.companyText}>
                                    <div className={classes.poweredByTic}>
                                        <span style={styles.byText}><span style={styles.poweredText}>Powered</span> by </span><span style={styles.ticText}> TIC</span>
                                    </div>
                                    <div>
                                        <span style={styles.bigText}>
                                            Copyright © {year} COTEMAR S.A. de C.V. Todos los derechos reservados.
                                            Este sistema pertenece, es operado y monitoreado por Grupo Cotemar S.A. de C.V. y contiene información confidencial propiedad de Cotemar.
                                            Cualquier acceso o uso no autorizado a este sistema por la administración de Cotemar no será permitido y podrá ser reportado a las autoridades competentes y/o ser objeto de alguna acción civil.
                                            Si usted no está autorizado a accesar o usar este sistema, desconectese ahora.
                                        </span>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Drawer>}
            <div>

                {/* <Modal
                    destroyOnClose={true}
                    visible={visibleModal}
                    width={'650px'}
                    centered={true}
                    closable={false}
                    footer={
                        [

                            <Button key="submit" type="primary" loading={false} onClick={() => sessionOut()}>
                                Aceptar
                            </Button>
                        ]
                    }
                >
                     <div style={{ textAlign: 'center' }}>
                            <img
                                alt="time"
                                src={require("../assets/time.png")}
                                style={{ width: '30%' }}
                            />
                            <h2>Tiempo de sesión expirado</h2>
                            <p>Por seguridad hemos finalizado tu <br></br>
                                sesión por inactividad</p>
                        </div>
                </Modal> */}
                <IdleTimer ref={idleTimer} timeout={1000 * 60 * 30} onIdle={onIdle} ></IdleTimer>
            </div>
        </div>
    );
}
export default withRouter(NavMenu);